import React from 'react'
import PropTypes from 'prop-types'

import VirtualVisitInverted from '@scoir/brand-icons/dist/VirtualVisitInverted'

const VirtualVisitLink = ({ placename }) => {
  return (
    <a
      className="virtual-visit-link-comp"
      href={placename}
      target="_blank"
      rel="noopener noreferrer"
    >
      Launch Meeting &nbsp;
      <VirtualVisitInverted />
    </a>
  )
}
VirtualVisitLink.propTypes = {
  placename: PropTypes.string.isRequired,
}

export default VirtualVisitLink
